// src/services/dashboardService.js
import apiClient from '../api/apiClient';
import { API_ENDPOINTS } from '../api/apiEndpoints';
import { getErrorMessage } from '../utils/apiError';

const dashboardService = {
  /**
   * Admin dashboard: GET /api/Dashboard -> ApiResponse<DashboardResponse>
   * Order counts are by current state (totalPendingOrders, totalAwaitingVerificationOrders, totalPaidUndeliveredOrders,
   * totalDeliveredOrders, totalFailedOrders, totalCancelledOrders, totalRefundedOrders); revenue figures count paid
   * orders only; latestUsers carries { id, fullName, email, role, status, createdDate } only.
   */
  getDashboardStats: async () => {
    try {
      const response = await apiClient.get(API_ENDPOINTS.DASHBOARD.GET_STATS);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: getErrorMessage(error, "Couldn't load the dashboard"),
      };
    }
  },
};

export default dashboardService;
